import axiosInstance from './axiosConfig';

// Custom API utility functions
export const api = {
  // Generic API methods
  get: (url, config = {}) => axiosInstance.get(url, config),
  post: (url, data = {}, config = {}) => axiosInstance.post(url, data, config),
  put: (url, data = {}, config = {}) => axiosInstance.put(url, data, config),
  delete: (url, config = {}) => axiosInstance.delete(url, config),
  patch: (url, data = {}, config = {}) => axiosInstance.patch(url, data, config),

  // Convenience method for API calls with automatic token handling
  request: (config) => axiosInstance.request(config),
};

// Export the axios instance for direct use if needed
export { axiosInstance };
export default api;
